import { Box, useColorScheme } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { matchPath, Outlet, useLocation } from 'react-router-dom';

import { Routes, RoutesWithFooter, RoutesWithHeader } from '@/constants';
import { AppLayout, ErrorBoundary, PageErrorBoundary } from '@/containers';
import { usePageViewEvents, useRouteProtection } from '@/hooks';
import { appSettingsActions, selectAppTheme, useAppDispatch } from '@/store';

export const AppRouteWrapper = () => {
  const dispatch = useAppDispatch();
  const { isAllowed } = useRouteProtection();
  const { pathname } = useLocation();

  usePageViewEvents();

  const appTheme = useSelector(selectAppTheme);
  const { setMode } = useColorScheme();

  useEffect(() => {
    window.muiTheme = {
      toggle: () => {
        // const newTheme = appTheme === 'dark' ? 'light' : 'dark';
        dispatch(appSettingsActions.setTheme('light'));
      },
    };
  }, [appTheme, dispatch, setMode]);

  const { isRouteWithHeader, isRouteWithFooter } = useMemo(
    () => ({
      isRouteWithHeader: Object.values(RoutesWithHeader).some(route =>
        matchPath(route, pathname),
      ),
      isRouteWithFooter: Object.values(RoutesWithFooter).some(route =>
        matchPath(route, pathname),
      ),
    }),
    [pathname],
  );

  if (!isAllowed) return null;

  // TODO discuss with team
  const errorBoundaryKey = pathname.startsWith(Routes.LEARNING_PATHS)
    ? Routes.LEARNING_PATHS
    : pathname;

  const Content = (
    <ErrorBoundary key={errorBoundaryKey} View={PageErrorBoundary}>
      <Box>
        <Outlet />
      </Box>
    </ErrorBoundary>
  );

  if (isRouteWithHeader || isRouteWithFooter)
    return (
      <AppLayout showFooter={isRouteWithFooter} showHeader={isRouteWithHeader}>
        {Content}
      </AppLayout>
    );

  return Content;
};
